export default __webpack_public_path__ + "static/flag-dk-6420931309b396bdee3d622d562ec9ea.svg";